import { render } from "./InitiativeCategoryForm.vue?vue&type=template&id=dcc382fc&scoped=true"
import script from "./InitiativeCategoryForm.vue?vue&type=script&lang=js"
export * from "./InitiativeCategoryForm.vue?vue&type=script&lang=js"

import "./InitiativeCategoryForm.vue?vue&type=style&index=0&id=dcc382fc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcc382fc"]])

export default __exports__